export enum NameplateOEMCodes {
  PASSENGER = 'Passenger',
}
